import Tooltip from "@/components/tooltip"
import { useMemo } from "react"

type HeatItem = { color: string | null; title?: string }

type Props = {
  items: HeatItem[]
  size?: number
  gap?: number
  maxPixels?: number
  rounded?: boolean
  cols?: number
  className?: string
}

export default function UnitRiskHeatmap({
  items,
  size = 8,
  gap = 2,
  maxPixels = 120,
  rounded = true,
  cols,
  className
}: Props) {
  const data = useMemo(() => items.slice(0, maxPixels), [items, maxPixels])
  const autoCols = useMemo(() => Math.max(6, Math.round(Math.sqrt(Math.max(1, data.length)))), [data.length])
  if (data.length === 0) return null

  return (
    <div
      className={`grid ${className ?? ""}`.trim()}
      style={{ gridTemplateColumns: `repeat(${cols ?? autoCols}, ${size}px)`, gap }}>
      {data.map((it, i) => (
        <Tooltip text={it.title} position="top" key={i}>
          <div
            style={{
              width: size,
              height: size,
              background: it.color ? it.color : "#fff",
              borderRadius: rounded ? 3 : 0,
              border: it.color ? "none" : "1px solid #8C8C8C",
              boxSizing: "border-box"
            }}
          />
        </Tooltip>
      ))}
    </div>
  )
}
